import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@material-ui/core';

import './addButton.css';

class AddButton extends React.Component {
    render() {
        const { onClick } = this.props;
        return (
            <div className="add-button-wrapper">
                <Button type="fab" onClick={onClick} className="add-button">
                    +
                </Button>
            </div>
        );
    }
}

AddButton.defaultProps = { onClick: undefined };
AddButton.propTypes = { onClick: PropTypes.func.isRequired };

export default AddButton;



// WEBPACK FOOTER //
// ./src/components/richButtons/addButton/index.jsx